export const API_REQUEST_VALIDATION_RULES = {
    first_name: {
        presence: true,
        length: { minimum: 1, maximum: 255 },
    },
    last_name: {
        presence: true,
        length: { minimum: 1, maximum: 255 },
    },
    email: {
        presence: true,
        email: true,
    },
    password: {
        presence: true,
        length: { minimum: 8 },
    },
    password_confirmation: {
        presence: true,
        equality: "password"
    },
    agreed_tac: {
        checked: true,
    },
    what_data: {
        presence: true,
        length: { minimum: 10 },
    },
    what_for: {
        presence: true,
        length: { minimum: 10 },
    },
    business_segment: {
        presence: true,
        length: { minimum: 1, maximum: 100 },
    },
    business_subsegment: {
        presence: true,
        length: { minimum: 1, maximum: 255 },
    },
    est_volume: {
        presence: true,
        length: { minimum: 1, maximum: 1000 },
    },
    website: {
        presence: true,
        length: {min: 1, max: 1000}
    },
    location: {
        presence: true,
        length: { minimum: 1, maximum: 500 },
    },
    phone: {
        length: { maximum: 50 },
    },
    token: {
        presence: true,
        format: {
            pattern: "[0-9]{6}",
            message: "must have 6 digits"
        }
    }
};
